"use strict";
var appn;
(function (appn) {
    var sessionStorage;
    (function (sessionStorage) {
        function getItem(key) {
            let item = null;
            try {
                const ssValue = window.sessionStorage.getItem(key);
                item = ssValue ? JSON.parse(ssValue) : null;
            }
            catch (e) {
                if (e && e.message)
                    console.log(e.message);
            }
            return item;
        }
        sessionStorage.getItem = getItem;
        function setItem(key, value) {
            let isSet = true;
            try {
                window.sessionStorage.setItem(key, JSON.stringify(value));
            }
            catch (e) {
                isSet = false;
                if (e && e.message)
                    appn.log.error(e.message, true);
            }
            return isSet;
        }
        sessionStorage.setItem = setItem;
        function removeItem(key) {
            try {
                window.sessionStorage.removeItem(key);
            }
            catch (e) {
                if (e && e.message)
                    console.log(e.message);
            }
        }
        sessionStorage.removeItem = removeItem;
        function clearAll() {
            try {
                window.sessionStorage.clear();
            }
            catch (e) {
                if (e && e.message)
                    console.log(e.message);
            }
        }
        sessionStorage.clearAll = clearAll;
    })(sessionStorage = appn.sessionStorage || (appn.sessionStorage = {}));
})(appn || (appn = {}));
